import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import EventIcon from '@mui/icons-material/Event';
import PersonIcon from '@mui/icons-material/Person';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import React from 'react';
import PixQRCode from './qrcode';
import { useTranslation } from '../../hooks/useTranslation';

const ResumePopup = ({ open, onClose, nome, email, quantidade, valor, resumeId }) => {
  const { t } = useTranslation();
  const dataAtual = new Date();
  const dataFormatadaBR = dataAtual.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent
        sx={{
          backgroundColor: '#1e1e1e',
          padding: '30px',
          position: 'relative',
          textAlign: 'center',
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 16, top: 16, color: '#aaa' }}
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" sx={{ color: '#76d361', fontWeight: 'bold', mb: 2 }}>
          {t('payment.orderCreatedSuccess')}
        </Typography>

        <Typography variant="body2" sx={{ color: '#ccc', mb: 3 }}>
          {t('payment.completePaymentInstructions')}
        </Typography>

        <Box sx={{ mb: 2 }}>
          {/* QR CODE SIMULADO */}
          {PixQRCode(valor, resumeId)}
        </Box>

        <Box
          sx={{
            backgroundColor: '#181818',
            borderRadius: '12px',
            padding: '20px',
            textAlign: 'left',
          }}
        >
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: 2,
            }}
          >
            <InfoItem icon={<ReceiptLongIcon />} label={t('forms.id')} value={resumeId} />
            <InfoItem icon={<PersonIcon />} label={t('forms.name')} value={nome} />
            <InfoItem icon={<EmailIcon />} label={t('forms.email')} value={email} />
            <InfoItem
              icon={<ShoppingCartIcon />}
              label={t('payment.tokenQuantity')}
              value={quantidade}
            />
            <InfoItem
              icon={<AttachMoneyIcon />}
              label={t('payment.totalValue')}
              value={`R$ ${valor}`}
            />
            <InfoItem
              icon={<EventIcon />}
              label={t('payment.paymentDate')}
              value={dataFormatadaBR}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

const InfoItem = ({ icon, label, value }) => (
  <Box>
    <Typography
      variant="body1"
      sx={{
        display: 'flex',
        alignItems: 'center',
        fontSize: 16,
        color: '#aaa',
      }}
    >
      {React.cloneElement(icon, { sx: { mr: 1, color: '#7db362' } })}
      <strong>{label}</strong>
    </Typography>
    <Typography variant="body2" sx={{ fontSize: 16, color: '#ccc', pl: 4 }}>
      {value}
    </Typography>
  </Box>
);

export default ResumePopup;
